<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="车牌/车主名称/单位名称/联系人名称/主机名称/分组名称"
             style="width: 300px; margin-right: 3px;"></Input>
      <DatePicker type="daterange" :start-date="new Date()" size="small" placement="bottom-end"
                  placeholder="到费日期范围" style="width: 200px;margin-right: 3px;"
                  v-model="dateFilter"></DatePicker>
      <CheckboxGroup style="display: inline-block" size="small"  v-model="filterType" @on-change="onFilterTypeChange">
<!--        <Checkbox label="停止服务"></Checkbox>-->
<!--        <Checkbox label="驾培车"></Checkbox>-->
<!--        <Checkbox label="加强筛选"></Checkbox>-->
        <Checkbox label="新增数据"></Checkbox>
      </CheckboxGroup>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="computeCol" :stripe="true" :data="content" ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <combo-vehicle-info-detail-modal v-model="comboVehicleInfoDetailModal" :initValue="comboVehicleInfoDetailId"
                                     @on-success="onModifySuccess"></combo-vehicle-info-detail-modal>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <combo-vehicle-pub-info-detail-modal v-model="comboVehiclePubInfoDetailModal"
                                         :initValue="comboVehiclePubInfoDetailId"
                                         @on-success="onModifySuccess"></combo-vehicle-pub-info-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import ComboVehicleInfoDetailModal from '@/view/crm/components/combo-vehicle-info-detail-modal'
import ComboVehiclePubInfoDetailModal from '@/view/crm/components/combo-vehicle-pub-info-detail-modal'
import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else if (colorid === 5) {
    return '#ffffff'
  } else {
    return '#000000'
  }
}

function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else if (colorid === 5) {
    return '#009900'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'combovehicleinfos',
  components: {
    ComboVehicleInfoDetailModal,
    BusinessNoteDetailModal,
    ComboVehiclePubInfoDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      pubBusinessStateFilter: null,

      filterType: ['加强筛选'],

      comboVehiclePubInfoDetailModal: false,
      comboVehiclePubInfoDetailId: null,

      // 潜在合拼车辆详细信息
      comboVehicleInfoDetailModal: false,
      comboVehicleInfoDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        comboVehicleInfoId: null
      },

      startDate: null,
      endDate: null,
      dateFilter: [],
      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      pageSize: 0,
      content: [],
      totalElements: 0,
      columnsDisplay: [],
      columnHeaders: [],
      columns: [
        // {
        //   title: 'ID',
        //   key: 'id',
        //   sortable: 'custom',
        //   tooltip: 'true',
        //   minWidth: 80,
        //   fixed: 'left'
        // },
        {
          title: '车牌',
          resizable: true,
          key: 'registrationNum',
          tooltip: 'true',
          width: 120,
          fixed: 'left',
          render: (h, params) => {
            if (params.row.newRecord) {
              return h('Button', {
                props: {
                  disabled: false
                },
                style: {
                  backgroundImage: 'url(\'/newlogo.png\')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '18px 18px',
                  backgroundColor: calRegistrationColor(params.row.registrationColor),
                  color: calRegistrationTextColor(params.row.registrationColor)
                },
                on: {
                  click: () => {
                    this.onDetailClick(params.row.id)
                  }
                }
              }, params.row.registrationNum)
            } else {
              return h('Button', {
                props: {
                  disabled: false
                },
                style: {
                  backgroundColor: calRegistrationColor(params.row.registrationColor),
                  color: calRegistrationTextColor(params.row.registrationColor)
                },
                on: {
                  click: () => {
                    this.onDetailClick(params.row.id)
                  }
                }
              }, params.row.registrationNum)
            }
          }
        },
        // {
        //   title: '分组/单位/车主',
        //   resizable: true,
        //   key: 'groupId',
        //   sortable: 'custom',
        //   tooltip: 'true',
        //   width: 320,
        //   // maxWidth: 450,
        //   render: function (h, params) {
        //     return h('div', [
        //       h('div', params.row.groupName),
        //       h('div', params.row.customCompanyName),
        //       h('div', params.row.vehicleOwnerName)
        //     ])
        //   }
        // },
        {
          title: '车主名称',
          key: 'vehicleOwnerName',
          tooltip: 'true',
          minWidth: 180
        },
        {
          title: '单位名称',
          key: 'customCompanyName',
          tooltip: 'true',
          minWidth: 200
        },
        // {
        //   title: '主机名称',
        //   resizable: true,
        //   key: 'deviceName',
        //   tooltip: 'true',
        //   width: 140
        // },
        {
          title: '年审时间',
          resizable: true,
          sortable: 'custom',
          tooltip: 'true',
          key: 'serviceMatureDate',
          width: 160,
          render: function (h, params) {
            if (params.row.serviceMatureDate) {
              let d = new Date(params.row.serviceMatureDate)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '我的笔记状态',
          resizable: true,
          tooltip: 'true',
          width: 140,
          render: (h, params) => {
            if (params.row.businessNote) {
              const state = params.row.businessNote.businessState
              if (state === 1) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'error'
                    }
                  }, '待开发')
                ])
              } else if (state === 3) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'primary'
                    }
                  }, '继续沟通')
                ])
              } else if (state === 4) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'black'
                    }
                  }, '沟通未果')
                ])
              } else if (state === 11) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'success'
                    }
                  }, '同意入网')
                ])
              }
            } else {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'error'
                  }
                }, '待开发')
              ])
            }
          }
        },
        {
          title: '颜色标签',
          resizable: true,
          ellipsis: 'true',
          width: 100,
          render: function (h, params) {
            if (params.row.businessNote) {
              if (params.row.businessNote.colorLabel) {
                return h('div', {
                  style: {
                    display: 'block',
                    width: '40px',
                    height: '20px',
                    backgroundColor: '#' + params.row.businessNote.colorLabel
                  }
                }, ' ')
              }
            }
          }
        },
        {
          title: '我的笔记内容',
          resizable: true,
          tooltip: 'true',
          minWidth: 200,
          render: (h, params) => {
            if (params.row.businessNote) {
              return h('label', params.row.businessNote.content)
            }
          }
        },
        {
          title: '公开笔记',
          resizable: true,
          tooltip: 'true',
          minWidth: 200,
          render: (h, params) => {
            if (params.row.businessNotes) {
              let businessNotes = params.row.businessNotes
              let display = []
              businessNotes.forEach(item => {
                // console.log('检测')
                // console.log(item)
                let displayName = null
                if (item.user.realName) {
                  displayName = item.user.realName
                } else if (item.user.nickName) {
                  displayName = item.user.nickName
                } else if (item.user.name) {
                  displayName = item.user.name
                }

                let tag = null
                if (item.pubType === 2) {
                  tag = h('Row', [displayName])
                } else if (item.pubType === 3) {
                  let bs = null
                  const state = item.businessState
                  if (state === 1) {
                    bs = h('Tag', {
                      props: {
                        color: 'red'
                      }
                    }, '待开发')
                  } else if (state === 3) {
                    bs = h('Tag', {
                      props: {
                        color: 'blue'
                      }
                    }, '继续沟通')
                  } else if (state === 4) {
                    bs = h('Tag', {
                      props: {
                        color: 'black'
                      }
                    }, '沟通未果')
                  } else if (state === 11) {
                    bs = h('Tag', {
                      props: {
                        color: 'green'
                      }
                    }, '同意入网')
                  } else {
                    bs = h('Tag', {
                      props: {
                        color: 'red'
                      }
                    }, '未定义')
                  }
                  tag = h('Row', [displayName, bs, item.content])
                }
                // let displayItem = h('div', [tag])
                display.push(tag)
              })

              return h('div', display)
            }
          }
        },
        {
          title: '公共状态',
          resizable: true,
          tooltip: 'true',
          width: 160,
          filters: [
            { label: '待开发', value: 1 },
            { label: '继续沟通', value: 3 },
            { label: '沟通未果', value: 4 },
            { label: '同意入网', value: 11 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              // this.pubBusinessStateFilter = genQueryParam('pubBusinessState', 'EQ', val[0])
              this.pubBusinessStateFilter = []
              val.forEach(item => {
                this.pubBusinessStateFilter.push(genQueryParam('pubBusinessState', 'EQ', item))
              })
            } else {
              this.pubBusinessStateFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.pubBusinessState) {
              const state = params.row.pubBusinessState
              if (state === 1) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'error'
                    }
                  }, '待开发')
                ])
              } else if (state === 3) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'primary'
                    }
                  }, '继续沟通')
                ])
              } else if (state === 4) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'black'
                    }
                  }, '沟通未果')
                ])
              } else if (state === 11) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'success'
                    }
                  }, '同意入网')
                ])
              }
            } else {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'error'
                  }
                }, '待开发')
              ])
            }
          }
        },
        {
          title: '公共备注',
          resizable: true,
          key: 'pubRemark',
          tooltip: 'true',
          minWidth: 150
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 250,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.onDetailClick(params.row.id)
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: params.row.businessNoteId == null ? 'primary' : 'success',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.businessNoteInfo.comboVehicleInfoId = params.row.id
                    this.businessNoteInfo.id = params.row.businessNoteId
                    this.businessNoteDetailModal = true
                  }
                }
              }, '业务笔记'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.comboVehiclePubInfoDetailId = params.row.id
                    this.comboVehiclePubInfoDetailModal = true
                  }
                }
              }, '公开信息')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'ComboVehicleInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onColumnsChange () {
      // let show = false
      // this.columnsDisplay.forEach(item => {
      //   if (item === '公共备注') {
      //     show = true
      //   }
      // })
      //
      // if(show){
      //   this.columns[9] = null
      //   console.log('隐藏')
      // }else{
      //   this.columns[9].width = null
      //   console.log('显示')
      // }
    },
    onFilterTypeChange () {
      this.refreshPage(this.pageFilter)
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      // console.log(this.dateFilter)
      if (this.dateFilter.length==0) {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.refreshPage(this.pageFilter)
    },
    onDetailClick (id) {
      this.comboVehicleInfoDetailId = id
      this.comboVehicleInfoDetailModal = true
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let qo1 = null
      let sortParam = null

      if (this.startDate && this.endDate) {
        queryParams.push(genQueryParam('serviceMatureDate', 'BTDT', this.startDate, this.endDate))
      }

      let i = 0

      let stopService = false
      for (i = 0; i < this.filterType.length; i++) {
        if (this.filterType[i] === '停止服务') {
          stopService = true
          break
        }
      }

      let learn = false
      for (i = 0; i < this.filterType.length; i++) {
        if (this.filterType[i] === '驾培车') {
          learn = true
          break
        }
      }

      let strengthen = false
      for (i = 0; i < this.filterType.length; i++) {
        if (this.filterType[i] === '加强筛选') {
          strengthen = true
          break
        }
      }

      let newrecord = false
      for (i = 0; i < this.filterType.length; i++) {
        if (this.filterType[i] === '新增数据') {
          newrecord = true
          break
        }
      }

      if (newrecord) {
        queryParams.push(genQueryParam('newRecord', 'EQBOOL', true))
      }

      if (strengthen) {
        queryParams.push(genQueryParam('strengthen', 'EQBOOL', false))
      }

      if (!learn) {
        queryParams.push(genQueryParam('learn', 'EQBOOL', false))
      }

      if (!stopService) {
        queryParams.push(genQueryParam('stopService', 'EQBOOL', false))
      }

      queryParams.push(genQueryParam('police', 'EQBOOL', false))
      queryParams.push(genQueryParam('test', 'EQBOOL', false))

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.pubBusinessStateFilter) {
        qo1 = this.pubBusinessStateFilter
      }

      store.dispatch('ComboVehicleInfoServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_ComboVehicleInfo_GetPageResult) {
          this.totalElements = store.getters.get_ComboVehicleInfo_GetPageResult.totalElements
          this.content = store.getters.get_ComboVehicleInfo_GetPageResult.content
          this.pageSize = store.getters.get_ComboVehicleInfo_GetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    computeCol () {
      let columns = this.columns
      columns = columns.filter(col => {
        for (var i = 0; i < this.columnsDisplay.length; i++) {
          if (this.columnsDisplay[i] === col.title) {
            return true
          }
        }
        return false
      })
      return columns
    }
    // totalElements() {
    //   if (store.getters.get_ComboVehicleInfo_GetPageResult) {
    //     return store.getters.get_ComboVehicleInfo_GetPageResult.totalElements
    //   } else {
    //     return 0
    //   }
    // },
    // content() {
    //   if (store.getters.get_ComboVehicleInfo_GetPageResult) {
    //     return store.getters.get_ComboVehicleInfo_GetPageResult.content
    //   } else {
    //     return []
    //   }
    // },
    // pageSize() {
    //   if (store.getters.get_ComboVehicleInfo_GetPageResult) {
    //     return store.getters.get_ComboVehicleInfo_GetPageResult.size
    //   } else {
    //     return 0
    //   }
    // }
  },
  mounted () {
    this.$nextTick(() => {
      this.columns.forEach(item => {
        this.columnHeaders.push(item.title)
        this.columnsDisplay.push(item.title)
      })
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
